import { render } from "./OldReportPage.vue?vue&type=template&id=585dfca0&scoped=true&ts=true"
import script from "./OldReportPage.vue?vue&type=script&lang=ts"
export * from "./OldReportPage.vue?vue&type=script&lang=ts"

import "./OldReportPage.vue?vue&type=style&index=0&id=585dfca0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-585dfca0"]])

export default __exports__